import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryNav() {
  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            探索漫画分类
          </h2>
          <p className="text-sm text-foreground-500 mt-2">
            八大品类，总有一款适合你
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-4 md:p-5 rounded-xl bg-background-100 hover:bg-primary-50 border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer"
            >
              <span className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                <i className={`${cat.icon} text-lg md:text-xl`}></i>
              </span>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-400">{cat.count}部</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}